"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preconditions_ts_1 = require("preconditions-ts");
exports.getInitials = function (name) {
    var initials = name.match(/\b\w/g) || [];
    return initials.map(function (i) { return i.toUpperCase(); }).join('');
};
exports.isOwner = function (signedInUser, handle) {
    if (!signedInUser.handle) {
        return false;
    }
    return signedInUser.handle === handle;
};
exports.makeFeatureUser = function (req, hasProSubscription) {
    return {
        sessionId: preconditions_ts_1.required(req.sessionToken && req.sessionToken.session_id),
        userId: req._signedin_user && req._signedin_user.handle,
        hasProSubscription: hasProSubscription,
    };
};
var replacement = [
    // react does encoding of &amp;, &quot, etc.
    // encoding < > here for extra safety
    [/>/gi, '\u003E'],
    [/</gi, '\u003C'],
];
exports.escapeControlCharacters = function (raw) {
    return replacement.reduce(function (c, v) { return c.replace(v[0], v[1]); }, raw);
};
exports.removeHtmlTags = function (raw) {
    var regex = /(<([^>]+)>)/gi;
    return raw.replace(regex, '');
};
exports.escapeHtml = function (raw) {
    if (!raw) {
        return raw;
    }
    return exports.escapeControlCharacters(exports.removeHtmlTags(raw));
};
exports.strToCurrency = function (str) {
    return str === 'usd' ? 'USD' : 'EUR';
};
exports.validUrl = function (testUrl) {
    // from http://urlregex.com/
    // tslint:disable-next-line:max-line-length
    return /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/.test(testUrl);
};
